var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    clipPath: "url(#clip0_231_22000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624374",
    x: 0.263672,
    width: 62.0001,
    height: 62,
    rx: 24.8,
    fill: "url(#paint0_linear_231_22000)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.7721 18.4465H21.029C16.9592 18.4465 13.6602 21.7457 13.6602 25.8153V36.1848C13.6602 40.2545 16.9594 43.5536 21.029 43.5536H41.7721C45.8418 43.5536 49.1409 40.2544 49.1409 36.1848V25.8153C49.1409 21.7457 45.8417 18.4465 41.7721 18.4465ZM36.7885 31.5045L27.0864 36.1317C26.8278 36.2551 26.529 36.0668 26.529 35.7804V26.2366C26.529 25.9459 26.8357 25.7576 27.0946 25.889L36.7966 30.8055C37.0855 30.9517 37.0803 31.3655 36.7885 31.5045Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_231_22000",
    x1: 31.2637,
    y1: 0,
    x2: 31.2637,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01F15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_22000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.0001,
    height: 62,
    fill: "white",
    transform: "translate(0.400391)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ff59f314869f92edf4932d49d4bb36d5.svg";
export { ForwardRef as ReactComponent };